// frontend/src/site/theme/getSiteTheme.js
import { SITE_PRESETS } from './presets';

function clamp(n, min, max) {
  const x = Number(n);
  if (!Number.isFinite(x)) return min;
  return Math.max(min, Math.min(max, x));
}

function pick(cfg, preset, key) {
  const v = cfg?.[key];
  return v === undefined || v === null || v === '' ? preset?.[key] : v;
}

function normalizePresetId(raw) {
  const key = String(raw || '')
    .trim()
    .toLowerCase();
  return key || 'humano_a';
}

// ✅ fallback: se não tiver preset, tenta styleId+paletteId
function buildPresetFromStylePalette(cfg) {
  const s = String(cfg?.styleId || '')
    .trim()
    .toLowerCase();
  const p = String(cfg?.paletteId || '')
    .trim()
    .toLowerCase();
  if (!s || !p) return '';
  return `${s}_${p}`;
}

export function getSiteTheme(perfilSite) {
  const cfg = perfilSite?.siteConfig || {};

  const requestedRaw =
    cfg.preset || buildPresetFromStylePalette(cfg) || 'humano_a';

  const requested = normalizePresetId(requestedRaw);

  const fallback =
    SITE_PRESETS.humano_a ||
    SITE_PRESETS.autoridade_a ||
    Object.values(SITE_PRESETS)[0] ||
    {};

  const preset = SITE_PRESETS[requested] || fallback;

  const presetCardStyle = preset?.cardStyle || 'flat';
  const presetButtonStyle = preset?.buttonStyle || 'outline';
  const presetLayoutDensity = preset?.layoutDensity || 'normal';

  return {
    preset: preset?.id || 'humano_a',
    mode: pick(cfg, preset, 'mode') || 'light',

    bg: pick(cfg, preset, 'bg') || '#FFFFFF',
    text: pick(cfg, preset, 'text') || '#0F172A',
    muted: pick(cfg, preset, 'muted') || '#64748B',
    card: pick(cfg, preset, 'card') || '#FFFFFF',
    border: pick(cfg, preset, 'border') || '#E2E8F0',
    accent: pick(cfg, preset, 'accent') || '#2563EB',
    accentText: pick(cfg, preset, 'accentText') || '#FFFFFF',

    fontHeading:
      pick(cfg, preset, 'fontHeading') || '"Inter", system-ui, sans-serif',
    fontBody: pick(cfg, preset, 'fontBody') || '"Inter", system-ui, sans-serif',
    headingWeight:
      Number(pick(cfg, preset, 'headingWeight')) || preset.headingWeight || 600,
    bodyWeight:
      Number(pick(cfg, preset, 'bodyWeight')) || preset.bodyWeight || 400,
    letterSpacingHeading: String(
      pick(cfg, preset, 'letterSpacingHeading') ??
        preset.letterSpacingHeading ??
        '-0.02em'
    ),
    lineHeightHeading:
      Number(pick(cfg, preset, 'lineHeightHeading')) ||
      preset.lineHeightHeading ||
      1.15,

    radius: clamp(pick(cfg, preset, 'radius'), 10, 34),

    cardStyle: presetCardStyle,
    buttonStyle: presetButtonStyle,
    layoutDensity: presetLayoutDensity,

    iconStyle: pick(cfg, preset, 'iconStyle') || 'stroke',
  };
}

export function themeToVars(theme) {
  const t = theme || {};
  return {
    '--bg': t.bg || '#FFFFFF',
    '--text': t.text || '#0F172A',
    '--muted': t.muted || '#64748B',
    '--card': t.card || '#FFFFFF',
    '--border': t.border || '#E2E8F0',
    '--accent': t.accent || '#2563EB',
    '--accentText': t.accentText || '#FFFFFF',

    '--radius': `${Number.isFinite(Number(t.radius)) ? t.radius : 14}px`,

    '--fontHeading': t.fontHeading || '"Inter", system-ui, sans-serif',
    '--fontBody': t.fontBody || '"Inter", system-ui, sans-serif',

    '--headingWeight': String(t.headingWeight || 600),
    '--bodyWeight': String(t.bodyWeight || 400),
    '--letterSpacingHeading': String(t.letterSpacingHeading || '-0.02em'),
    '--lineHeightHeading': String(t.lineHeightHeading || 1.15),
  };
}
